<script setup>
import {ref} from 'vue'
import {Link} from '@inertiajs/vue3'
import IconAngleLeft from '@js/components/Icons/IconAngleLeft.vue'

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    items: {
        type: Array,
        default: () => [],
    },
    initiallyOpen: {
        type: Boolean,
        default: false,
    },
})

const isOpen = ref(props.initiallyOpen)

const toggle = () => {
    isOpen.value = !isOpen.value
}
</script>

<template>
    <div class="border-b border-gray-200 pb-5">

        <!-- Заголовок аккордеона -->
        <button
            type="button"
            @click="toggle"
            class="w-full flex items-center justify-between font-medium text-left"
        >
            <span>{{ title }}</span>

            <IconAngleLeft
                class="w-5 h-5 rotate-180 transition-transform duration-200"
                :class="{'-rotate-90': isOpen}"
            />
        </button>

        <!-- Контент -->
        <transition
            enter-active-class="transition-all duration-200 ease-out"
            enter-from-class="opacity-0 max-h-0"
            enter-to-class="opacity-100 max-h-[1000px]"
            leave-active-class="transition-all duration-200 ease-in"
            leave-from-class="opacity-100 max-h-[1000px]"
            leave-to-class="opacity-0 max-h-0"
        >
            <div v-if="isOpen" class="overflow-hidden pt-4">
                <div class="flex flex-col gap-4">

                    <Link
                        v-for="(item, index) in items"
                        :key="`${title}-${index}`"
                        :href="item.href"
                        class="text-sm font-medium text-gray-700 md:hover:text-navHoverColor transition"
                    >
                        <span class="leading-tight">
                            {{ item.title }}
                        </span>
                    </Link>

                </div>
            </div>
        </transition>

    </div>
</template>
